// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { Action } from "redux"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { TIMESHEET_FIELDS_VIEW_TYPE } from "../../../app/localStorageKeys"

export type StorageReader = () => Observable<Slice.TimesheetFieldsViewType>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(TIMESHEET_FIELDS_VIEW_TYPE)
    if (data !== null) {
      // convert to number for matching index from TimesheetFieldsViewType enum
      return of(Number(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadTimesheetFieldsViewType = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.loadTimesheetFieldsViewTypeFromStorage.match),
      mergeMap(_ => load().pipe(
        map(Slice.setTimesheetFieldsViewType),
        catchError(_ => of(Actions.loadTimesheetFieldsViewTypeFromStorageFailed())),
      )),
    )

export default loadTimesheetFieldsViewType(load)
